import React, {useState} from 'react';
import {useStyles} from './dnacpr_styles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {Trans, useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {patient} from '../../../../store/reducers/patient';
import {user} from '../../../../store/reducers/user';
import {Grid} from '@mui/material';
import {
    DetailsAndRationaleLabels,
    DiscussionLabels,
    DNACPROrderStatus,
    ImplantableCardioverter,
    MentalCapacityLabels,
    StepsMatrix,
} from './dnacpr_data';
import moment from 'moment';
import InformationBox from '../../../../components/other/informationBox';
import AgyleDialog from '../../../../components/modal/agyleDialog';
import AgyleTextField from '../../../../components/ui/fields/agyleTextField';
import AgyleDatePicker from '../../../../components/ui/fields/agyleDatePicker';
import IconButton from '@mui/material/IconButton';

function InlineFormDNACPRView(props) {
    const [f_DNACPR, setF_DNACPR] = useState(props.form);

    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const patientObject = useSelector(patient);
    const userObject = useSelector(user);

    const dicts = {
        mentalCapacity: MentalCapacityLabels,
        detailsAndRationale: DetailsAndRationaleLabels,
        discussion: DiscussionLabels,
        implantableCardioverter: ImplantableCardioverter
    }

    const handleClose = () => {
        props.closeForm();
    }

    const getResultBlock = (value) => {
        if(value != null) {
            return (
                <div className={classes.answerBlock}>
                    {value=="y" &&
                        <span>{t("YES")}</span>
                    }
                    {value=="n" &&
                        <span>{t("NO")}</span>
                    }
                </div>
            )
        }
    }

    const getQuestionsMentalCapacityBlock = () => {
        let formRows = [];
        let subMatrix = ["q0"]
        let buildMatrix = ["q0"];
        while(subMatrix.length > 0) {
            subMatrix.forEach((questionaryPart) => {
                if(questionaryPart.substring(0,1) == "q"){
                    let key = questionaryPart + "value";
                    if (f_DNACPR.mentalCapacity[key] != null) {
                        if (f_DNACPR.mentalCapacity[key] == "y") {
                            subMatrix = StepsMatrix[questionaryPart]["y"];
                        } else {
                            subMatrix = StepsMatrix[questionaryPart]["n"];
                        }
                    } else {
                        subMatrix = [];
                    }
                }
            });
            buildMatrix.push(...subMatrix)
        }
        buildMatrix.forEach((qPart) => {
            switch(qPart.substring(0,1)){
                case "q":
                    formRows.push(getQuestion('mentalCapacity', qPart));
                    break;
                case "i":
                    formRows.push(getInfo('mentalCapacity', qPart));
                    break;
                case "l":
                    formRows.push(getTextResponse('mentalCapacity', qPart));
                    break;
            }
        })
        return formRows;
    }

    const getQuestion = (group, key) => {
        //key short one like in dicts
        if(f_DNACPR[group][key+"value"] != null) {
            return (
                <table className={classes.questionAnswer}>
                    <tbody>
                        <tr key={group + "_" + key + "_qKey"}>
                            <td>
                                <Trans>
                                    {dicts[group]['questions'][key]}
                                </Trans>
                            </td>
                            <td className={classes.questionAnswerBlock}>
                                {getResultBlock(f_DNACPR[group][key+"value"])}
                            </td>
                        </tr>
                    </tbody>
                </table>
            )
        } else {
            return (<span></span>)
        }
    }

    const getInfo = (group, key) => {
        if(!Array.isArray(key)) {
            key = [key];
        }

        return ( <Grid item xs={12} key={key[0] + "_info"}>
            <InformationBox type="info" fullWidth>
                { key.map((elKey) => {
                    //Used Trans because of issue with colon sign!!!
                    return (<div key={group + "_info-block_" + elKey}><Trans>{dicts[group]['infos'][elKey]}</Trans></div>)
                }) }
            </InformationBox>

            </Grid> )
    }

    const getTextResponse = (group, key) => {
        return (
            <Grid item xs={12}>
                {/*{group}{key}*/}
                <div className={classes.textAnswer}>
                    {f_DNACPR[group][key]}
                </div>
            </Grid>
        )
    }

    const debatersBlock = () => {
        return (
            <table className={classes.consultedWith} cellSpacing={0} cellPadding={0}>
                <thead>
                    <tr>
                        <th className={classes.consultedHeader}>{t('Name')}</th>
                        <th className={classes.consultedHeader}>{t('Relationship/Role')}</th>
                    </tr>
                </thead>
                <tbody>
                    { getDebaters() }
                </tbody>
            </table>
        )
    }

    const getDebaters = () => {
        let debaters = [];
        f_DNACPR.discussion.debaters.forEach((debater) =>{
            debaters.push(
                <tr key={debater.id}>
                    <td className={classes.consultedData}>
                        { debater.name }
                    </td>
                    <td className={classes.consultedData}>
                        { debater.role }
                    </td>
                </tr>
            )
        });
        return debaters;
    }

    const getValidUntilDates = () => {
        let validDates = [];
        f_DNACPR.awaiting?.forEach((awaiting) => {
            validDates.push(
                <Grid item xs={4}>
                    <span>
                        { awaiting.validAddedBy }
                    </span>
                </Grid>);
            validDates.push(
                <Grid item xs={4}>
                    <span>
                        { awaiting.validAddedSetDate ? moment(awaiting.validAddedSetDate).format("DD/MM/YYYY") : "" }
                    </span>
                </Grid>);
            validDates.push(
                <Grid item xs={4}>
                    <span>
                        { awaiting.validAddedDate ? moment(awaiting.validAddedDate).format("DD/MM/YYYY") : "" }
                    </span>
                </Grid>);
        });
        return validDates;
    }

    const isPending = () => {
        return (f_DNACPR.signedById == null && f_DNACPR.deactivateDate == null && f_DNACPR.status == DNACPROrderStatus.AVAITING);
    }

    const [addCounterSignModalView, setAddCounterSignModalView] = React.useState(false);
    const [cancelDNACPRModalView, setCancelDNACPRModalView] = React.useState(false);
    const [cancelReason, setCancelReason] = React.useState("");
    const [extendDate, setExtendDate] = React.useState(f_DNACPR.validUntilDate ? f_DNACPR.validUntilDate : null);
    const [extendDNACPRModalView, setExtendDNACPRModalView] = React.useState(false);

    const dispatch = useDispatch();

    const topModalShowClose = (topModalName, openClose, decision) => {
        switch(topModalName) {
            case "addCounterSign":
                if(decision) {
                    props.onCounterSign({user: userObject, form: f_DNACPR, canceledReason: cancelReason})
                   // dispatch(countersignDNACPR({user: userObject, form: f_DNACPR}))
                }
                setAddCounterSignModalView(openClose);
                break;
            case "cancel":
                if(decision) {
                    props.onDelete({user: userObject, form: f_DNACPR, canceledReason: cancelReason})
                    //dispatch(cancelDNAR({user: userObject, form: f_DNACPR, canceledReason: cancelReason}))
                }
                setCancelDNACPRModalView(openClose);
                break;
            case "extend":
                if(decision) {
                 //   dispatch(extendDNAR({user: userObject, form: f_DNACPR, newValidUntilDate: extendDate}))
                    props.onExtendDNAR({user: userObject, form: f_DNACPR, newValidUntilDate: extendDate})
                }
                setExtendDNACPRModalView(openClose);
                break;
        }
        if(decision && !openClose) {
            props.closeForm();
        }
    }

    return (
        <div>
            <div >
                <div className={classes.root}>

                    <h1 className={classes.title}>
                        <IconButton
                            variant="contained"
                            color="inherit"
                            size={"small"}
                            onClick={handleClose}
                        >
                            <ArrowBackIcon />
                        </IconButton>
                        <Trans>'DO NOT ATTEMPT Cardiopulmonary Resuscitation (DNACPR)'</Trans>
                        <div className={classes.subtitle}><Trans>ORDER</Trans></div>
                    </h1>
                </div>
                <div className={classes.sheet}>
                    {f_DNACPR.signedById == null && f_DNACPR.createById !== userObject.__id &&
                        <div className={classes.dnacprContrSignBlock}>
                            <Trans>Order is currently awaiting countersignature.</Trans>
                            <div className={classes.btnSign} onClick={ () => {
                                    topModalShowClose('addCounterSign', true)
                            }}>
                                {t("Countersign")}
                            </div>
                        </div>
                    }
                    <div>
                        {isPending(f_DNACPR) &&
                            <div className={classes.btnSignGreen} onClick={() => {
                                    topModalShowClose('extend', true)
                                }}>
                                {t("Extend DNAR")}
                            </div>
                        }
                        {f_DNACPR.status !== DNACPROrderStatus.CANCELED &&
                            <div className={classes.btnSign} onClick={ () => {
                                    topModalShowClose('cancel', true)
                                }}>
                                {t("Cancel DNAR")}
                            </div>
                        }
                    </div>
                    <Grid container className={classes.borderedHeader}>
                        <Grid item xs={4}>
                            <span className={classes.theader}>
                                {t("Created by")}
                            </span>
                        </Grid>
                        <Grid item xs={4}>
                            <span className={classes.theader}>
                                {t("Created")}
                            </span>
                        </Grid>
                        <Grid item xs={4}>
                            <span className={classes.theader}>
                                {t("Valid until / Review Date")}
                            </span>
                        </Grid>
                    </Grid>
                    <Grid container>
                        { getValidUntilDates() }
                    </Grid>
                    <div>
                        { getQuestionsMentalCapacityBlock() }
                    </div>
                    <div>
                        { getInfo("detailsAndRationale", ["i1", "i2", "i3", "i4", "i5"]) }
                        { getTextResponse("detailsAndRationale", "description") }
                    </div>
                    <div>
                        { getQuestion("discussion", "q0") }
                        { getInfo("discussion", "i0") }
                        { (f_DNACPR.discussion.q0value && f_DNACPR.discussion.q0value=="y") &&
                            <Grid container>
                                <Grid item xs={12}>
                                    { debatersBlock() }
                                </Grid>
                                <Grid item xs={12}>
                                    <div>
                                        <div className={classes.labelInline}>
                                            {t("Discussion with patient led by")}
                                        </div>
                                        <div className={classes.textAnswerInline}>
                                            {f_DNACPR["discussion"]["discussionDoctor"]}
                                        </div>
                                        <div className={classes.labelInline}>
                                            {t("Date")}
                                        </div>
                                        <div className={classes.textAnswerInline}>
                                            { f_DNACPR && f_DNACPR.discussion && f_DNACPR.discussion.discussionDate ? moment(f_DNACPR["discussion"]["discussionDate"]).format("DD/MM/YYYY") : ""}
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        }
                        { (f_DNACPR.discussion.q0value && f_DNACPR.discussion.q0value=="n") &&
                            <Grid container>
                                { getInfo("discussion", "i1") }
                                { getTextResponse("discussion", "l0value") }
                            </Grid>
                        }
                    </div>
                    <div>
                        { getQuestion("implantableCardioverter", "q0") }
                        { getQuestion("implantableCardioverter", "q1") }
                        {(f_DNACPR.implantableCardioverter.q1value && f_DNACPR.implantableCardioverter.q1value == "y" && f_DNACPR.implantableCardioverter.deactivateDate != null) &&
                            <div>
                                <div>
                                    {t("Date deactivated")}
                                </div>
                                <div className={classes.textAnswer}>
                                    { f_DNACPR && f_DNACPR.implantableCardioverter && f_DNACPR.implantableCardioverter.deactivateDate ? moment(f_DNACPR["implantableCardioverter"]["deactivateDate"]).format("DD/MM/YYYY") : ""}
                                </div>
                            </div>
                        }
                        { getQuestion("implantableCardioverter", "q2") }
                    </div>
                </div>
            </div>

            {addCounterSignModalView &&
                <AgyleDialog
                    title={t("Countersign")}
                    open={addCounterSignModalView}
                    submitText={"Yes"}
                    onClose={() => {
                        topModalShowClose('addCounterSign', false,false);
                    }}
                    onSave={() => {
                        topModalShowClose('addCounterSign', false, true);
                    }}
                >
                    <div >
                        {t("Do you wish to countersign this DNACPR order")}?
                    </div>

                </AgyleDialog>
            }

            {cancelDNACPRModalView &&
                <AgyleDialog
                    title={t("Cancel DNAR")}
                    open={cancelDNACPRModalView}
                    onClose={() => {
                        topModalShowClose('cancel', false,false);
                    }}
                    onSave={() => {
                        topModalShowClose('cancel', false,true);
                    }}
                >
                    <div>
                        <div className={classes.inputlabel} style={{marginTop: 0, width: 250}}>{t("Reason for Cancelation")}</div>
                        <div>
                            <AgyleTextField
                                value={cancelReason}
                                onChange={(event) => {
                                    setCancelReason(event.target.value);
                                }}
                                size="small"
                                textFieldClass={classes.input}
                                fullWidth
                            />
                        </div>
                    </div>

                </AgyleDialog>
            }


            {extendDNACPRModalView &&
                <AgyleDialog
                    title= {t("Extend DNAR")}
                    open={extendDNACPRModalView}
                    onClose={() => {
                        topModalShowClose('extend', false,false);
                    }}
                    onSave={() => {
                        topModalShowClose('extend', false,true);
                    }}
                >
                    <div>
                        <div className={classes.inputlabel} style={{marginTop: 0, width: 250}}>{t("New valid until/review date")}</div>

                        <AgyleDatePicker
                            type="date"
                            disableFuture={false}
                            minDate={moment(f_DNACPR.validUntilDate)}
                            textFieldClass={classes.input}
                            value={extendDate}
                            onChange={
                                (event) => {
                                    setExtendDate(event);
                                }}
                        />
                    </div>

                </AgyleDialog>
            }

        </div>

    )
}

export default InlineFormDNACPRView;